import React from "react";

const CornerSmall = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.665039 0H15.7762C16.2671 0 16.665 0.397969 16.665 0.888889C16.665 1.37981 16.2671 1.77778 15.7762 1.77778H2.44282V15.1111C2.44282 15.602 2.04485 16 1.55393 16C1.06301 16 0.665039 15.602 0.665039 15.1111V0Z"
      fill="currentColor"
    />
  </svg>
);

export default CornerSmall;
